import { post, get } from '@/utils/request'
import axios from 'axios'
import {encryptMD5} from '@/utils'
import store from '@/store'
/**
 * 获取活动专题--商品列表
 * @param {Object} data
 * {activityId:'',currentPageNumber:'',numberOfImpressions:''},
 */
export function getActivityGoodsList (data) {
  return post('/miniapps/commodity/selectActivityCommodityList', data)
}

/**
 * 获取活动专题--商品详情
 * @param {Object} data
 * {commodityId:''} 商品ID
 */
export function getActivityGoodsDetails (data) {
  return get('/miniapps/commodity/selectCommodityDetails', data)
}
/**
 * 获取活动专题--商品参数
 * @param {Object} data
 * {commodityId:''} 商品ID
 */
export function getGoodsParameter (data) {
  return get('/miniapps/commodity/selectCommodityParameter', data)
}

/**
 * 商品详情-推荐相似列表
 * @param {Object} data
 * {brandId:'',categoryId:''} 商品ID
 */
export function getRecommendList (data) {
  return post('/miniapps/commodity/selectRecommendedSimilar', data)
}
/**
 * 猜你喜欢列表
 * @param {Object} data
 * {brandId:'',categoryId:''} 商品ID
 */
export function getGuessLikeList (data) {
  return get('/miniapps/commodity/selectGuessLike', data)
}

/**
 * 获取活动专题列表
 * @param {Object} data
 * {classification:'',activityArea:'',currentPageNumber:'',numberOfImpressions:''},
 */
export function getActivityList (data) {
  return post('/miniapps/activity/selectSpecialTopicActivityList', data)
}

/**
 * 获取指定优惠卷商品列表
 * @param {Object} data
 * 
 */
export function getPrivilegeGoodsList (data) {
  return post('/miniapps/commodity/selectAppointPrivilegeCommodityList', data)
}

/**
 * 活动专题详情
 * @param {Object} data
 * {activityId:''},
 */
export function getActivityDetails (data) {
  return get('/miniapps/activity/selectSpecialTopicActivityDetails', data)
}

/**
 * 活动专题详情
 * @param {Object} data
 * {goodsId:'',userToken:''}
 */
export function putWishGoods (data) {
  return post('/wishOrder/order/create', data)
}

/**
 * 获取特殊渠道销售商品详情
 * @param {Object} data
 * 
 */
export function getSaleCommodityDetails (data) {
  return get('/miniapps/commodity/selectSpecialSaleCommodityDetails', data)
}


/**
 * 获取取货列表
 * 
 */
// 创建 axios 接口
const instance = axios.create({
  baseURL: 'https://search.ponhu.cn',
  timeout: 10000,
  responseType: "json"
})

// request拦截器
instance.interceptors.request.use(config => {
  let key = 'phcloud_h5';
  let sign_type = 'md5';
  let timestamp = Math.round(new Date().getTime() / 1000).toString() + "000"
  let sign = encryptMD5(key + '&' + sign_type + '&' + timestamp)
  // let timestamp = Date.parse(new Date()).toString();
  // let sign = encryptMD5(key + '&' + sign_type + '&' + timestamp + '&' + encryptMD5(timestamp).substring(8, 20).toUpperCase());
  // config.headers = { 
  //   'Content-Type': 'application/json',
  //   'appkey': key,
  //   'timestamp': timestamp,
  //   'sign_type': sign_type,
  //   'token':  store.getters.token || ' ',
  //   'sign': sign
  // }
  const data = {
    "channelId" : 2,
    "sign" : sign,
    "timestamp" : timestamp,
    "sign_type" : sign_type,
    "appkey" : key
  }
  if (config.method === 'post') {
    config.params = data
    config.data = JSON.stringify(config.data)
  } else {
    config.params = {
      ...config.params,
      ...data
    }
  }
  return config
}, error => {
   return Promise.reject(error)
})

export function getFindSearchKey(params = {}) {
  return new Promise((resolve, reject) => {
    instance.get('/client/search', {
      params: params
    }).then(response => {
      resolve(response);
    }).catch(err => {
      reject(err)
    })
  })
}





